import { actionCreators as assignmentFormActionCreators } from '@app/components/AssignmentForm/modules/assignmentForm'
import { connect } from 'react-redux'
import AssignmentEditPage from '../components/AssignmentEditPage'

export default connect(
  null,
  assignmentFormActionCreators,
)(AssignmentEditPage)
